import styled from 'styled-components/macro';
import { OrderActionSubtitleText, OrderActionTitleText } from '../../common/fontElements';

export const AddressWrapper = styled.div`
  margin: 4rem;
  label {
    color: #7f7f7f;
    font-family: lato, sans-serif;
    line-height: 1.8rem;
    font-weight: 700;
  }
`;

export const RadioButtons = styled.div`
  display: inline-flex;
  flex-direction: column;
`;

export const RadioButtonInput = styled.input`
  font-family: 'Lato-Light', sans-serif;
  margin-right: 5px !important;
  background-color: #ffffff;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 10px 0 0 0;
`;

export const PrimaryButton = styled.button`
  background-color: #44b1df;
  border: 0 #787878;
  border-radius: 2.2rem;
  color: #ffffff;
  font-family: lato, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.3rem;
  padding: 0.5rem 2rem;

  &:hover {
    background-color: #545454;
  }
`;

export const ErrorMessageWrapper = styled.div`
  width: 100%;
  text-align: center;
  color: #ff4d44;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
`;

export const RadioButtonWrap = styled.div`
  padding: 10px 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

// Wrapper
export const OrderTaskWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > * {
    margin: 10px 0;
  }

  padding: 0 20px;
`;

// Title
export const OrderTaskTitle = styled(OrderActionTitleText)`
  text-align: left;
`;

export const OrderTaskDescription = styled(OrderActionSubtitleText)`
  text-align: left;
`;

// Controls row
export const OrderTaskControls = styled.div`
  min-height: 48px;
  padding-top: 1.2rem;
  padding-bottom: 1.2rem;
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
`;
